import countries from "i18n-iso-countries";
import { getNames } from "country-list";

try { countries.registerLocale(require("i18n-iso-countries/langs/en.json")); } catch {}

const normalizeAlpha2 = (value = "") => {
  const trimmed = String(value || "").trim();
  if (!trimmed) return "";
  if (/^[a-z]{2}$/i.test(trimmed)) {
    return trimmed.toLowerCase();
  }
  try {
    const code = countries.getAlpha2Code(trimmed, "en");
    return code ? code.toLowerCase() : "";
  } catch {
    return "";
  }
};

export const getAlpha2 = (name = "") => normalizeAlpha2(name);

export const getCountryName = (code = "") => {
  const normalized = normalizeAlpha2(code);
  if (!normalized) return "";
  try {
    return countries.getName(normalized.toUpperCase(), "en") || "";
  } catch {
    return "";
  }
};

let _cache = null;
export const getCountryRecords = () => {
  if (_cache) return _cache;
  const names = getNames(); 
  _cache = names
    .map((name) => {
      const code = getAlpha2(name);
      if (!code) return null;
      return {
        value: code,
        label: name,
        code,
        name,
      }; 
    })
    .filter(Boolean);
  return _cache;
};
